module.exports = __webpack_public_path__ + "img/customerService.8c3fd2fd.svg";